import { render, staticRenderFns } from "./ChatMessageList.vue?vue&type=template&id=935de780&scoped=true&"
import script from "./ChatMessageList.vue?vue&type=script&lang=js&"
export * from "./ChatMessageList.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageList.vue?vue&type=style&index=0&id=935de780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935de780",
  null
  
)

export default component.exports